import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import './tour.css';
import { Autoplay } from 'swiper/modules';
import { motion, AnimatePresence } from 'framer-motion';

function C2wTour ({ isVisible } ) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [images, setImages] = useState(
    [
      "Image26.png",
     "Image1.jpeg",
     "Image2.jpeg",
     "Image25.png",
     "Image3.jpeg",
     "Image4.jpeg",
     "Image5.jpeg",
     "Image6.jpeg",
     "Image7.jpeg",
     "Image8.jpeg",
     "Image9.jpeg",
     "Image10.jpeg",
     "Image11.jpeg",
     "Image12.jpeg",
     "Image13.jpeg",
     "Image14.jpeg",
     "Image15.jpeg",
     "Image16.jpeg",
     "Image17.jpeg",
     "Image18.jpeg",
     "Image19.jpeg",
     "Image20.jpeg",
     "Image21.jpeg",
     "Image22.jpeg",
     "Image23.png",
     "Image24.png"
    
    ]

  )

  const slidesWithHiddenActive = [
    ...images.filter((_, index) => index !== activeIndex), 
    images[activeIndex] 
  ];

  /**
 * @hook useEffect - Interval to update activeIndex state every 2 seconds
 * @author Vishal Lohbande
 *
 * Description:
 * - Sets up an interval timer that runs every 2000 milliseconds (2 seconds).
 * - On each interval tick, calls `setActiveIndex` with the current value of `activeIndex`.
 * - The interval resets whenever `activeIndex` changes.
 *
 * Behavior:
 * - Effect depends on `activeIndex`, so it clears and restarts the interval whenever `activeIndex` updates.
 * - Cleans up interval on component unmount or before re-running effect to prevent memory leaks.
 *
 * Notes:
 * - Currently, `setActiveIndex(activeIndex)` sets the state to the same value, which doesn't trigger re-render.
 * - Consider updating `activeIndex` with a new value inside the interval callback for meaningful updates (e.g., incrementing).
 */
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(activeIndex)
    }, 2000);
    return () => clearInterval(interval);
  }, [activeIndex]);

  /**
 * @function handleSlideChange
 * @author Vishal Lohbande
 *
 * Description:
 * - Event handler to update the active slide index when the swiper changes slides.
 *
 * Parameters:
 * - `swiper`: The swiper instance object which contains current slide information.
 *
 * Behavior:
 * - Sets the state `activeIndex` to the `realIndex` of the currently active slide from the swiper.
 *
 * Usage:
 * - Typically used as a callback for swiper/slider components to keep track of the current active slide index.
 */
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
  }

  /**
 * @state windowWidth
 * @hook useEffect - Window Resize Listener
 * @author Vishal Lohbande
 *
 * Description:
 * - Initializes `windowWidth` state with the current window width.
 * - Adds a resize event listener on the window to update `windowWidth` whenever the window size changes.
 *
 * Behavior:
 * - The `handleResize` function updates the `windowWidth` state with the new window width.
 * - Cleanup function removes the event listener on component unmount to prevent memory leaks.
 *
 * Usage:
 * - Useful for responsive design decisions based on the current viewport width.
 */
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  

  return (
    windowWidth > 620 ? (
      <div className="C2wTourPage_ctn">
        <div className="C2wTourPage_gallery">
          <div className="C2wTourPage_ctn_heading">
            <div className="C2wTourPageHeading_holder">
              <span>{'Some glimpse of our'}</span>
              <div className="C2wTourPageHeading_holder_span">
                <span>{'Institute'}</span>
              </div>
            </div>
            <img className="C2wTourPageHeadingCircles" src="/assets/images/landing/tourPageCircle.svg" alt="leftCircleIcons" />
          </div>
          <AnimatePresence>
            <motion.div
              key={activeIndex}
              className="C2w_TourPage_active_img"
              style={{ backgroundImage: (`url(/assets/images/gallery/${images[activeIndex]})`) }}
              initial={{ opacity: 0, x: 10, scale: 0.8 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: '-100%', scale: 0.8 }}
              transition={{ duration: 0.5 }}
            >
            </motion.div>
          </AnimatePresence>
          <Swiper className='swiper-slide-inActive' 
            modules={[ Autoplay ]}
            loop={true}
            onSlideChange={handleSlideChange}
            autoplay={{
              delay: 1500,
            }}
            breakpoints={{
              620: {   
                slidesPerView: 4,
                spaceBetween: 10,
              }, 
              1240: {   
                slidesPerView: 4,
                spaceBetween: 30,
              },
              1358: {   
                slidesPerView: 4,
                spaceBetween: 48,
              },
              1366: {   
                slidesPerView: 4,
                spaceBetween: 50,
              },
              1440: {   
                slidesPerView: 4,
                spaceBetween: 40,
              },
              1536: {   
                slidesPerView: 4,
                spaceBetween: 38,
              },
              1540: {   
                slidesPerView: 4,
                spaceBetween: 40,
              },
              1600: {
                slidesPerView: 4,
                spaceBetween: 48,
              },
              1920: {   
                slidesPerView: 5,
                spaceBetween: 38,
              },
            }}
          >
            {slidesWithHiddenActive.map((src, index) => (
        <SwiperSlide
          key={index}
          className="Inactive_Swiper-slide_img"
          style={{
            backgroundImage: `url(/assets/images/gallery/${src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <motion.div
            className="Inactive_Swiper_motion"
            initial={{ opacity: 0.7, scale: 0.7 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          />
        </SwiperSlide>
      ))}
          </Swiper>

        </div>
      </div>
    ) : (
      <div className='C2wTourPage_ctn'>
        <div className="C2wTourPage_ctn_heading">
          <div className="C2wTourPageHeading_holder">
            <span>{'Some glimpse Of Our'}</span>
          </div>
          <div className="C2wTourPageHeading_holder_span">
            <span>{'Institute'}</span>
          </div>
        </div>
        <div className="C2wTourPage_gallery">
          <AnimatePresence>
            <motion.div
              key={activeIndex}
              className="C2w_TourPage_active_img"
              style={{ backgroundImage: (`url(/assets/images/gallery/${images[activeIndex]})`) }}
              initial={{ opacity: 0, x: 10, scale: 0.8 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: '-100%', scale: 0.8 }}
              transition={{ duration: 0.5 }}
            >
            </motion.div>
          </AnimatePresence>
          <Swiper className='swiper-slide-inActive'
            // slidesPerView={6}
            // spaceBetween={50}
            modules={[ Autoplay]} 
            loop={true}
            onSlideChange={handleSlideChange}
            autoplay={{
              delay: 1000,
              disableOnInteraction: true,
            }}
          >
            {images && images.map((src, index) => (
              <SwiperSlide className='Inactive_Swiper-slide_img'
                initial={{ opacity: 0.7, scale: 0.7 }}
                animate={{
                  scale: 0,
                  // opacity: activeIndex === index ? 0 : 1
                }}
                transition={{ duration: 0.3 }}
              >
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <img className="C2wTourPageHeadingCirclesMob" src="/assets/images/landing/tourPageCircle.svg" alt="leftCircleIcons" />
      </div>
      
    )
  );
}

export default C2wTour;
